/** Primeira palavra do nome (ex.: "Empresa Dois Ltda" → "Empresa"). */
export function getCompanyFirstToken(name: string): string {
	const trimmed = name.trim();
	if (!trimmed) return '';
	return trimmed.split(/\s+/)[0] ?? trimmed;
}

/** Dados mínimos para exibir nome/banner (empresa RH ou `GET /employees/me`). */
export type CompanyPortalProfileInput = {
	trade_name?: string | null;
	legal_name?: string | null;
	banner_img_url?: string | null;
	logo_img_url?: string | null;
};

/** Nome e banner para o portal empresa (GET /company/auth/me ou GET /employees/me). */
export function resolveCompanyPortalProfile(
	company: CompanyPortalProfileInput | null | undefined,
): {
	displayName: string;
	/** Nome curto para o slot do banner quando não há imagem. */
	headerTitle: string;
	bannerUrl: string | null;
} {
	const displayName =
		company?.trade_name?.trim() || company?.legal_name?.trim() || '';
	const headerTitle =
		getCompanyFirstToken(company?.trade_name?.trim() ?? '') ||
		getCompanyFirstToken(company?.legal_name?.trim() ?? '') ||
		displayName;
	const bannerUrl = company?.banner_img_url ?? company?.logo_img_url ?? null;
	return { displayName, headerTitle, bannerUrl };
}
